<script setup>
import ModalBase from "@/components/modal/ModalBase.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";
import ArgonLoadingButton from "@/components/ArgonLoadingButton.vue";
import { ref, onMounted, watch } from "vue";
import { apiKeyStore } from "@/_store/apikeyStore.js";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { useStore } from "vuex";
import { errorUtils } from "@/utils";

const emits = defineEmits(["close", "success"]);
const modalRef = ref(null);
const disableButton = ref(false);
const snackbar = ref(null);
const dataInputs = ref({ appName: "" });

const rules = {
  appName: {
    required: helpers.withMessage("Nombre es requerido", required),
  },
};
const v$ = useVuelidate(rules, dataInputs);
const apiStore = apiKeyStore();
const store = useStore();

function closeSnackbar() {
  snackbar.value = null;
}
function closeModal() {
  emits("close");
  modalRef.value?.closeModal();
}
function saveApiKey() {
  v$.value.$validate().then(() => {
    if (v$.value.$error) return;

    disableButton.value = true;
    apiStore.newApiKeys(dataInputs.value);
  });
}

watch(() => apiStore.send, (value) => {
  if (value) {
    emits("success", value);
    closeModal();
    snackbar.value = {
      title: "Creado",
      message: "Se ha creado la API Key",
      type: "info",
      color: "white",
    };
    apiStore.send = null;
    disableButton.value = false;
    v$.value.$reset();
    dataInputs.value.appName = "";
  }
});

watch(() => apiStore.error, (err) => {
  if (err) {
    snackbar.value = {
      title: "Error",
      message: errorUtils.getErrorMessageHtml(err),
      type: "danger",
      color: "white",
    };
    disableButton.value = false;
    apiStore.error = null;
  }
});

onMounted(() => {
  const bootstrap = store.state.bootstrap;
  const modalInstance = new bootstrap.Modal(document.getElementById("modalApiKey"), {
    keyboard: true,
  });
  modalInstance.show();
});
</script>


<template>
  <modal-base
    id="modalApiKey"
    ref="modalRef"
    width="30rem"
    min-height="15rem"
    @hide="closeModal"
  >
    <template #header>
      <h6 class="modal-title mb-0">Nueva</h6>
    </template>

    <template #body>
      <div class="row modal-form-row">
        <div class="modal-form-label">
          <label
              for="col-form-label"
              class="col-form-label required"
              >Nombre
            </label>
        </div>
        <div class="col">
          <argon-input
        v-model="dataInputs.appName" 
        :error="v$.appName.$error"
        :max-length="25"
      />
        </div>
      </div>
    </template>

    <template #footer>
      <argon-loading-button
        class="btn bg-gradient-primary btn-xs"
        color="primary"
        :label="disableButton ? 'Guardando...' : 'Guardar'"
        :loading="disableButton"
        :disable-button="disableButton"
        @click="saveApiKey"
      />
    </template>

    <div class="position-fixed top-0 end-0 z-index-2 p-3">
      <argon-snackbar
        v-if="snackbar"
        :title="snackbar.title"
        :description="snackbar.message"
        :icon="{ component: 'ni ni-notification-70', color: snackbar.type }"
        :color="snackbar.color"
        :close-handler="closeSnackbar"
      />
    </div>
  </modal-base>
</template>
